import React from 'react'
import {Box,Typography,Button} from '@mui/material'
import HeroImage from '../assests/images/1.jpg';
import '../styles/HeroBanner.css';
const HeroBanner = () => {
  return (
  <Box sx={{
    mt:{lg:'212px',xss:'70px'}, //mt-margin-top
    ml:{sm:'50px'} //ml=margin-left
  }}>
    <Typography fontWeight={700} sx={{fontSize:{lg:'44px',xs:'40px'}}} mb="23px" mt="30px">
      Sweat,Smile <br/> and Repeat
    </Typography>
    <Typography fontSize='22px' linearheight='35px'
    mb={4}>

      Check out the most effective exercises
    </Typography>
    <Button variant='contained'
    color='error'href='#exercises'
    sx={{backgroundColor:'ff2625', padding:'10px'}}>Explore Exercises</Button>
    <Typography fontWeight={600} color='#ff2625' sx={{
      opacity:0.1,display:{lg:'block',xs:'none'}
    }} fontSize="200px">Exercises</Typography>
<img src={HeroImage} alt='banner' className='hero-banner-img'/>
  </Box>
  )
}

export default HeroBanner